import { useInfiniteQuery } from '@tanstack/react-query'
import { gameBoxRoomDetailService } from '../../../../services/games/games-boxes-rooms-details'
import type { GetList } from '../../../../services/games/games-boxes-rooms-details/types'

export const GAMES_BOXES_ROOMS_DETAILS_QUERY_KEY = 'getGamesBoxesRoomsDetails'

export const useGetGamesBoxesRoomsDetails = (params: GetList.Input) => {
  const {
    data,
    isFetchingNextPage,
    isLoading,
    hasNextPage,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery({
    queryKey: [GAMES_BOXES_ROOMS_DETAILS_QUERY_KEY, params],
    initialPageParam: 0,
    queryFn: ({ pageParam: skip }) => {
      return gameBoxRoomDetailService.getList({ take: 20, skip, ...params })
    },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage?.error) return null

      if (lastPage && !lastPage?.data?.length) return null

      return lastPageParam + 1
    },
  })

  return {
    gamesBoxesRoomsDetails: data?.pages?.flatMap((page) => page?.data),
    isFetchingNextPage,
    isLoading,
    hasNextPage,
    nextPage: fetchNextPage,
    refetch,
  }
}
